<template>
  <DxPopup
    :visible="popupVisible"
    :drag-enabled="true"
    :close-on-outside-click="false"
    :show-title="true"
    :width="'90%'"
    :height="'80%'"
    :title="'Price Group Selection'"
    :showCloseButton="false"
    :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-price-group-select' }"
    @shown="onShown"
  >
    <DxToolbarItem
      v-for="(item, index) in toolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :options="item.options"
    />

    <div class="css-v2 transaction-list">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
        :rightContainerWidth="250"
      >
        <template #leftContent>
          <dx-data-grid
            v-if="popupVisible"
            :columnChooser="{ enabled: false }"
            :pager="{ visible: false }"
            :columns="gridColumns"
            :data-source="dataSource"
            :row-alternation-enabled="true"
            :selection="{ mode: 'multiple' }"
            :height="getGridHeight"
            :width="'100%'"
            @toolbar-preparing="onToolbarPreparing"
            @selection-changed="onSelectionChanged"
            @content-ready="onContentReady"
            ref="price-group-grid"
          >
            <DxSelection
              :select-all-mode="'allPages'"
              :show-check-boxes-mode="'always'"
              mode="multiple"
              :allowSelectAll="false"
            />
            <DxSearchPanel :visible="false" />
            <DxPaging :page-size="50" :enabled="true" />
            <DxScrolling mode="virtual" row-rendering-mode="virtual" />
          </dx-data-grid>
        </template>

        <template #rightContent>
          <gc-filter-panel
            :toolbarVisible="true"
            :toolbar="filterToolbar"
            :formItemData="filterFormItems"
            :setGridPanelFilter="setGridPanelFilter"
            :gridFoolter="false"
            :from="'model'"
            :isNormal="false"
            :persistenceKey="undefined"
            :key="'fp-price-group'"
            :overWriteClear="true"
            ref="gc-filter-panel"
            :heightAdjustment="filterHeightAdjustment"
          />
        </template>
      </gc-filter-split-view>
    </div>
  </DxPopup>
</template>

<script>
// import RouteMixin from "../../_mixins/route.mixin";
// import FormMixin from "../../_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { CustomerPriceGroupService } from "../../_services/api/customers/customer-price-group.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  props: {
    setVisible: {
      type: Boolean,
      default: false,
    },
    popupHiddenCallBack: {
      type: Function,
      default: () => {},
    },
    assignedPriceGroups: {
      type: Array,
      default: () => [],
    },
    customerCode: {
      type: String,
      default: "",
    },
    onSaveSuccess: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [DataGridMixin],
  data() {
    return {
      showLeftContainer: true,
      showRightContainer: true,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
        },
      },
      selectedItems: [],
      isSaving: false,
      height: "auto",
      filterHeightAdjustment: 0,

      initiateDataLoading: false,
      defaultFilterValues: [],
    };
  },
  async created() {
    setTimeout(() => {
      const el = document.querySelectorAll(
        ".gc-popup-price-group-select .dx-popup-content",
      )[0];
      if (el) {
        this.height = this.filterHeightAdjustment = el.clientHeight - 20;
      }
    }, 1);
  },
  computed: {
    getGridHeight() {
      return this.height;
    },
    popupVisible() {
      return !!this.setVisible;
    },
    toolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          visible: true,
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "success",
            disabled: this.isSaving,
            onClick: this.onSave,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          visible: true,
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            disabled: this.isSaving,
            onClick: this.closePopup,
          },
        },
      ];
    },
    dataSource() {
      if (this.initiateDataLoading) {
        return this.originalDataSourceConfig;
      } else {
        return [];
      }
    },

    originalDataSourceConfig() {
      return CustomerPriceGroupService.dataSourceConfig("api/PriceGroupList", {
        key: ["Code"],
        filter: this.defaultFilterValues,
      });
    },

    gridColumns() {
      return [
        {
          caption: "Code",
          dataField: "Code",
          width: 80,
          alignment: "left",
        },
        {
          caption: "Short Description",
          dataField: "ShortDescription",
          width: ColumnWidth.ShortDescription.width,
          minWidth: ColumnWidth.ShortDescription.minWidth,
        },
        {
          caption: "Description",
          dataField: "Description",
          width: ColumnWidth.Description.width,
          minWidth: ColumnWidth.Description.minWidth,
        },
        {
          caption: "Type",
          dataField: "FriendlyPriceGroupType",
          width: ColumnWidth.CustomerType.width,
          minWidth: ColumnWidth.CustomerType.minWidth,
        },
        {
          caption: "Sell Start Date",
          dataField: "SellStartDate",
          dataType: "date",
          format: "dd MMM yyyy",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
        },
        {
          caption: "Sell End Date",
          dataField: "SellEndDate",
          dataType: "date",
          format: "dd MMM yyyy",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
        },
      ];
    },
    filterFormItems() {
      return [
        {
          screenField: "DateIn",
          filterLabel: "Sell Start Date",
          filterDataField: "SellStartDate",
          type: "Date",
        },
        {
          screenField: "DateIn",
          filterLabel: "Sell End Date",
          filterDataField: "SellEndDate",
          type: "Date",
        },
        {
          screenField: "Status",
          filterLabel: "Type",
          filterDataField: "PriceGroupType",
          dataSourceConfig: {
            data: [
              { key: "Additional Discount", value: "A" },
              { key: "Off Invoice", value: "I" },
              { key: "Sales Discount", value: "S" },
            ],
          },
          valueExpr: "value",
          displayExpr: "key",
        },
      ];
    },
  },
  methods: {
    onShown() {
      this.showLoading(true);
      const assignedIds = this.assignedPriceGroups
        .filter((pg) => pg.Include !== false)
        .map((pg) => pg.PriceGroupID);

      let filterArr = [["Inactive", "=", "N"]];
      assignedIds.forEach((id) => {
        filterArr.push("and");
        filterArr.push(["Code", "<>", id]);
      });

      this.defaultFilterValues = filterArr;

      setTimeout(() => {
        this.showLoading(false);
      }, 500);
    },
    closePopup() {
      this.selectedItems = [];
      this.popupHiddenCallBack();
    },
    onSelectionChanged(e) {
      this.selectedItems = e.selectedRowsData;
    },
    onContentReady(e) {
      this.addGridNoResults(e, undefined);
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          icon: "filter",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
          visible: !this.showRightContainer,
        },
      });
    },
    setGridPanelFilter(e, valueChanged) {
      const dataGrid = this.$refs["price-group-grid"].instance;

      if (
        e.length === 0 &&
        valueChanged &&
        this.defaultFilterValues.length > 0
      ) {
        dataGrid.filter(this.defaultFilterValues);
        dataGrid.refresh(true);
      } else {
        if (this.initiateDataLoading == false) {
          dataGrid.option("dataSource", this.originalDataSourceConfig);
          this.initiateDataLoading = true;
        }

        if (dataGrid) {
          if (e.length > 0)
            dataGrid.filter([...e, "and", ...this.defaultFilterValues]);
          else dataGrid.filter(this.defaultFilterValues);

          dataGrid.refresh(true);
        }
      }
    },
    async onSave() {
      if (this.selectedItems.length === 0) {
        this.$alert(
          "Please select at least one price group to assign to the customer.",
          "Validation Error",
          {
            confirmButtonText: "OK",
          },
        );
        return;
      }

      this.showLoading(true);
      const newEntries = this.selectedItems.map((item) => ({
        PriceGroupID: item.Code,
        CustomerCode: this.customerCode,
        Include: true,
        InheritedMessage: "",
      }));

      const payload = {
        CustomerCode: this.customerCode,
        PriceGroups: [
          ...this.assignedPriceGroups.map((pg) => ({
            PriceGroupID: pg.PriceGroupID,
            CustomerCode: pg.CustomerCode || this.customerCode,
            Include: pg.Include,
            InheritedMessage: pg.InheritedMessage || "",
          })),
          ...newEntries,
        ],
      };

      this.isSaving = true;
      await CustomerPriceGroupService.save(payload)
        .then(() => {
          this.$notify("Price group assignments saved successfully", "success");
          this.onSaveSuccess();
          this.closePopup();
        })
        .catch((error) => {
          this.showLoading(false);
          this.displayServerError(
            error,
            "An error occurred while saving price group assignments. Please try again.",
          );
        })
        .finally(() => {
          this.showLoading(false);
          this.isSaving = false;
        });
    },
  },
};
</script>

<style lang="scss">
.gc-popup-price-group-select {
  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .advance-filter-panel .dx-form {
    padding-bottom: 10px !important;
  }
}
</style>
